import { Bubble, Props } from './Bubble';

export const CallAgainBubble = (props: Props) => {
  const onCall = () => {
    if (!props.message.canCall) {
      alert('無効なルームから電話をかけようとしています。');
      return;
    }
    props.onSend('通話開始');
  };

  return (
    <Bubble {...props}>
      <div className="bg-brand rounded-2xl px-4 py-3 drop-shadow-sm">
        <p className="leading-5 text-white">
          不在でした
          <br />
          {props.role === 'teller'
            ? 'ユーザーから電話がかかってきます'
            : 'こちらから再度電話をかけてください'}
        </p>
        <p className="text-white underline hover:cursor-pointer" onClick={onCall}>
          電話をかける
        </p>
      </div>
    </Bubble>
  );
};
